import React from 'react';
import '../../styles/WhyChoose.css';

const FEATURES = [
  {
    id: 1,
    tag: 'Live Sessions',
    title: 'Live Mentorship with Graduate FF',
    desc: 'Master viral YouTube hooks, algorithm pacing, and get live channel teardowns.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
      </svg>
    )
  },
  {
    id: 2,
    tag: 'Career Ready',
    title: 'High-Income Editing Skills',
    desc: 'Practical editing, pacing, and sound design tailored specifically for fast client monetization.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    )
  },
  {
    id: 3,
    tag: 'Verified',
    title: 'Accredited Certificates',
    desc: 'Complete the assignments and receive shareable certificates for your client pitches.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    )
  },
  {
    id: 4,
    tag: 'VIP Access',
    title: 'Creator Community Hub',
    desc: 'Collaborate and network with 50,000+ active editors, creators, and scriptwriters.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    id: 5,
    tag: '1-on-1 Help',
    title: 'Direct Project Feedback',
    desc: 'Get your timeline edits and portfolio cuts reviewed with actionable improvements.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    )
  },
  {
    id: 6,
    tag: 'Lifetime Access',
    title: 'Asset Vault & Free Updates',
    desc: 'Enjoy lifetime access to curriculum updates, sound packs, LUTs, and project templates.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  }
];

export default function WhyChoose() {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        
        
        <div className="why-choose-header">
          <span className="why-badge-pill">WHY CHOOSE CREATORS DOST</span>
          <h2 className="why-headline">
            Everything You Need to <span>Succeed.</span>
          </h2>
          <p className="why-subheadline">
            Practical skills, direct mentorship, and essential assets designed to grow your creative career.
          </p>
        </div>

        
        <div className="why-grid">
          {FEATURES.map((item) => (
            <div className="why-card" key={item.id}>
              <div className="why-card-top-row">
                <div className="why-icon-box">
                  {item.icon}
                </div>
                <span className="why-tag">{item.tag}</span>
              </div>
              <h3 className="why-card-title">{item.title}</h3>
              <p className="why-card-desc">{item.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}